import React, { useRef } from 'react'
import styles from './return.module.css'
import { useTranslation } from 'react-i18next'
import { Button, message, Space } from 'antd'
import EntranceForm from '../../organism/entrance/EntranceForm'
import { EBoxSize, ECompleteMethod, EEntranceOption } from '../tracking/type'
import PickupLocationForm from '../../organism/pickupLocation/PickupLocationForm'
import RequestForm from '../../organism/request/RequestForm'
import { putDeliveryComplete } from '../../../api/shippingApi'
import { useNavigate, useParams } from 'react-router-dom'
import { useDeliveryInfo } from '../../../api/useDeliveryInfo'
import { useShippingInfo } from '../../../api/useShippingInfo'
import { showMessageWithTitle } from '../../../common/message'
import { trackingDetailUrl } from "../../../common/consts.common";

export const ReturnPlace = () => {
  const { t } = useTranslation(['location'])
  const boxRef = useRef('')
  const boxPassRef = useRef('')
  const completeInfo = useRef('')
  const entranceCodeRef = useRef('')
  const entranceRef = useRef<EEntranceOption>()
  const completeMethodRef = useRef<ECompleteMethod>(ECompleteMethod.DOOR)
  const photoRef = useRef<File>()
  const boxSizeRef = useRef<EBoxSize>()
  const boxCountRef = useRef<number>()
  const [messageApi, messageHolder] = message.useMessage()

  const { tracking } = useParams()
  const { shipping } = useShippingInfo(tracking)
  const { deliveryInfo } = useDeliveryInfo(tracking)
  const navigate = useNavigate()

  const handleSaveResult = () => {
    putDeliveryComplete(
      messageApi,
      t,
      {
        entrance_option: entranceRef.current,
        entrance_password: entranceCodeRef.current,
        photo: photoRef.current,
        delivery_box_number: boxRef.current,
        delivery_box_password: boxPassRef.current,
        delivery_complete_on: completeMethodRef.current,
        delivery_complete_on_info: completeInfo.current,
        size: boxSizeRef.current,
        package_count: boxCountRef.current,
      },
      shipping?.tracking_number_return ? shipping.tracking_number_return : tracking,
      () => {
        showMessageWithTitle(t('popup.success.entry.content.return'))
        navigate(trackingDetailUrl(shipping?.tracking_number_return))
      }
    )
  }

  return (
    <Space direction={'vertical'} size={20}>
      {messageHolder}
      <div className={'round-cntr info-container'}>
        <div className={'h2'}>{t('pickup.location.info2')}</div>
      </div>
      {tracking && (
        <div className={'round-cntr ' + styles.trackingContainer}>
          <div className={'body2 preline'}>{`${t('Return tracking No')}: ${tracking}`}</div>
        </div>
      )}
      <RequestForm
        info={deliveryInfo}
        onCountChanged={count => (boxCountRef.current = count)}
        onSizeSelected={size => (boxSizeRef.current = size)}
        onSelectPhoto={photo => (photoRef.current = photo)}
      />
      <PickupLocationForm
        info={deliveryInfo}
        title={t('loc.return.title')}
        onBoxNumChange={boxNum => (boxRef.current = boxNum)}
        onBoxPasswordChange={pass => (boxPassRef.current = pass)}
        onCompleteMethodChange={method => (completeMethodRef.current = method)}
        onCompleteInfoChange={info => (completeInfo.current = info)}
      />
      <EntranceForm
        deliveryInfo={deliveryInfo}
        tracking={tracking}
        onEntrancePasswordChange={pass => (entranceCodeRef.current = pass)}
        onEntranceOptionChange={option => (entranceRef.current = option)}
      />
      <div className={'floating-btn-margin'} />
      <Button
        type={'primary'}
        size={'large'}
        className={'floating-btn'}
        data-cy={'saveResult'}
        onClick={handleSaveResult}
      >
        {t('btn.return.title')}
      </Button>
    </Space>
  )
}
